import { Button, Divider, Input, Select, Space } from "antd";
import { SaveOutlined } from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";

export const keyDetailsItems = (
  verdict,
  isChanging,
  handleStatusChange,
  inspectionDetails,
  verdictOptions,
  remarksChanged,
  handleRemarksChange,
  handleSaveRemarks,
  remarks
) => [
    {
      key: 'incomingPartName',
      label: 'IC Part Name',
      children: inspectionDetails?.incomingPart?.name,
      span: 3,
    },
    {
      key: 'supplierName',
      label: 'Supplier Name',
      children: inspectionDetails?.supplier?.name,
      span: 3,
    },
    {
      key: 'quantity',
      label: 'Total Order Quantity',
      children: inspectionDetails?.quantity,
      span: 3,
    },
    {
      key: 'samplingNumber',
      label: 'Sampling Size',
      children: inspectionDetails?.inspectionStats?.totalSamples,
      span: 3,
    },
    {
      key: 'totalOk',
      label: 'Total OK',
      children:
        <span style={{ color: "green", fontWeight: "bold" }}>
          {inspectionDetails?.inspectionStats?.totalOkSamples}
        </span>,
      span: 3,
    },
    {
      key: 'totalNok',
      label: 'Total NOK',
      children:
        <span style={{ color: "red", fontWeight: "bold" }}>
          {inspectionDetails?.inspectionStats?.totalNokSamples}
        </span>,
      span: 3,
    },
    {
      key: 'lotStatus',
      label: 'Lot Status',
      children: (
        inspectionDetails?.status !== 'OPEN'
          ? <Select
            loading={isChanging}
            value={verdict}
            placeholder="Select status"
            style={{ width: 120 }}
            onChange={handleStatusChange}
            options={verdictOptions}
            disabled={inspectionDetails?.status === 'CLOSED' || isChanging ? true : false}
            optionRender={(option) => (
              <div role="img" style={{ fontWeight: "bold", color: option.data.color }}>
                {option.data.label}
              </div>
            )}
          />
          : <></>
      ),
      span: 3,
    },
    {
      key: 'remarks',
      label: 'Remarks',
      children: (
        <div style={{ width: '100%' }}>
          <TextArea
            style={{ width: '50%' }}
            placeholder="Enter your remarks"
            value={remarks}
            onChange={handleRemarksChange}
            allowClear
          />
          <Divider type='vertical' />
          <Button type="primary" icon={<SaveOutlined />} disabled={!remarksChanged} onClick={handleSaveRemarks} />
        </div>
      ),
      span: 3,
    },
  ];